import usePostData from '../../../../../hooks/postHook';

export const useConfirmationAction = ({ id }) => {
  const [{ data, body, isLoading, isError, error }, doConfirm] = usePostData(
    `office_parcel/${id}/confirm_action`
  );

  return { data, body, isLoading, isError, error, doConfirm };
};
